<template>
    <div class="3xl:tw-mt-0 lg:tw-items-start tw-items-center tw-flex tw-flex-col lg:tw-ml-6 tw-mt-6 tw-ml-0">
        <p class="3xl:tw-mb-0 tw-text-[#161C2D] tw-font-poppins tw-text-2xl tw-font-semibold tw-mb-2">
            {{ displayName }}
        </p>

        <div class="tw-flex tw-flex-col lg:tw-items-start tw-items-center">
            <p
                v-if="isMobile || isTablet"
                class="tw-text-[#161C2D] tw-font-sans tw-text-xl tw-font-normal tw-mb-0"
            >
                {{ occupation }}
            </p>
            <p
                v-if="isMobile || isTablet"
                class="tw-text-[#161C2D] tw-font-sans tw-text-xl tw-font-normal tw-mb-0 tw-text-center"
            >
                {{ company }}
            </p>
            <p
                v-else
                class="tw-text-[#161C2D] tw-font-sans tw-text-xl tw-font-normal tw-mb-0"
            >
                {{ occupation }}<span v-if="company">{{ ', ' + company }}</span>
            </p>
            <p
                    v-if="userLicense"
                    class="tw-text-[#161C2D] tw-font-sans tw-text-base tw-font-normal tw-mb-8"
            >
                {{ 'NMLS' + `${userLicense}` }}
            </p>
        </div>
        <div
                v-if="phones && phones.length > 0"
                class="3xl:tw-mb-[0.5rem] xl:tw-h-8 tw-flex tw-justify-start tw-items-center tw-w-full tw-h-10 lg:tw-ml-0 tw-ml-12"
        >
            <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#064789] tw-w-[1.36413rem] tw-h-[1.36413rem] tw-mr-4"
                :style="{background: primaryColor}"
            >
                <i class="fa-solid fa-phone tw-text-white tw-text-[0.6875rem]"></i>
            </div>
            <p
                    v-for="(phone, index) in formattedPhones"
                    :key="index"
                    class="tw-text-[#262D3B] tw-font-sans tw-flex tw-text-base tw-font-semibold tw-leading-[1.5rem] tw-mb-0"
            >
                {{ phone }}
                <span
                        v-if="index < phones.length - 1 && phones.length > 1"
                        class="tw-mx-[0.2rem]"
                >
                    |
                </span>
            </p>
        </div>
        <div
                v-if="email"
                class="3xl:tw-mb-[0.5rem] xl:tw-h-8 tw-flex tw-justify-start tw-items-center tw-w-full tw-h-10 lg:tw-ml-0 tw-ml-12"
        >
            <div
                class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#064789] tw-w-[1.36413rem] tw-h-[1.36413rem] tw-mr-4"
                :style="{background: primaryColor}"
            >
                <i class="fa-solid fa-envelope tw-text-white tw-text-[0.6875rem]"></i>
            </div>
            <b-link
                    :href="`mailto:${email}`"
                    class="tw-text-[#262D3B] tw-font-sans tw-text-base tw-font-semibold tw-leading-[1.5rem] tw-underline tw-mb-0"
                    target="_blank"
                    title="Email"
            >
                Email Me
            </b-link>
        </div>
        <div
                v-if="website"
                class="3xl:tw-mb-[0.5rem]  xl:tw-h-8 tw-flex tw-justify-start tw-items-center tw-w-full tw-h-10 lg:tw-ml-0 tw-ml-12"
        >
            <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#064789] tw-w-[1.36413rem] tw-h-[1.36413rem] tw-mr-4"
                 :style="{background: primaryColor}"
            >
                <i class="fa-solid fa-globe tw-text-white tw-text-[0.6875rem] tw-font-[900]"></i>
            </div>
            <b-link
                    :href="website.url"
                    class="tw-text-[#262D3B] tw-font-sans tw-text-base tw-font-semibold tw-leading-[1.5rem] tw-underline tw-mb-0"
                    target="_blank"
                    title="Website"
            >
                Website
            </b-link>
        </div>
        <div
                v-if="activeListings"
                class="3xl:tw-mb-[0.5rem]  xl:tw-h-8 tw-flex tw-justify-start tw-items-center tw-w-full tw-h-10 lg:tw-ml-0 tw-ml-12"
        >
            <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#064789] tw-w-[1.36413rem] tw-h-[1.36413rem] tw-mr-4"
                 :style="{background: primaryColor}"
            >
                <i class="fa-solid fa-sign-hanging tw-text-white tw-text-[0.6875rem]"></i>
            </div>
            <b-link
                    v-if="activeListings"
                    :href="activeListings.url"
                    class="tw-text-[#262D3B] tw-font-sans tw-text-base tw-font-semibold tw-leading-[1.5rem] tw-underline tw-mb-0"
                    target="_blank"
                    title="Active Listings"
            >
                Active Listings
            </b-link>
        </div>
    </div>
</template>

<script>
import {formatPhoneUS} from "@milestoneslabs/milestones-ui-kit/src/helpers/phoneHelper";
import isMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

export default {
    name: 'UserDetails',
    components: {},
    mixins: [
        isMobileMixin,
    ],
    props: {
        displayName: {
            type: String,
            required: false,
        },
        agentOccupation: {
            type: Object,
            required: false,
        },
        license: {
            type: Object,
            required: false,
        },
        email: {
            type: String,
            required: false,
        },
        website: {
            type: Object,
            required: false,
        },
        phones: {
            type: Array,
            required: false,
        },
        activeListings: {
            type: Object,
            required: false,
        },
        companyName: {
            type: String,
            required: false,
        },
        primaryColor: {
            type: String,
            required: true,
        }
    },
    data() {
        return {};
    },
    computed: {
        occupation() {
            return this.agentOccupation?.name || 'Other';
        },
        company() {
            return this.companyName ? this.companyName : '';
        },
        userLicense() {
            if (this.license && this.license?.number) {
                return this.license?.number;
            }

            return '';
        },
        formattedPhones() {
            return this.phones.map(lpPhone => {
                return formatPhoneUS(lpPhone.phone);
            });
        }
    },
    methods: {

    },

};
</script>
